import { urls } from '../settings';
import * as HttpJsonService from './http-json-service';
import routes from './routes';

export const getApprovesTest = testId => HttpJsonService.postJson(urls.APPROVE_TEST(testId));

export const getCorrectionTest = testId => HttpJsonService.postJson(urls.CORRECTION_TEST(testId));

export const discardTest = testId => HttpJsonService.deleteJson(urls.DISCARD_TEST(testId));

export const postLogin = data => HttpJsonService.requestToken(data);

export const fetchUserData = () => HttpJsonService.getJson(urls.GET_USER_INFO);

export const fetchClasses = () =>
    HttpJsonService.getJson(urls.CLASSES(), { shallow: true });

export const fetchClass = classId =>
    HttpJsonService.getJson(urls.CLASSES(classId));

export const updateClass = (classId, data) =>
    HttpJsonService.patchJson(urls.CLASSES(classId), data);

export const createClass = data =>
    HttpJsonService.postJson(urls.CLASSES(), data);

export const deleteClass = classId =>
    HttpJsonService.deleteJson(urls.CLASSES(classId));

export const fetchCourses = () =>
    HttpJsonService.getJson(urls.COURSES(), { shallow: true });

export const fetchCourse = courseId =>
    HttpJsonService.getJson(urls.COURSES(courseId));

export const updateCourse = (courseId, data) =>
    HttpJsonService.patchJson(urls.COURSES(courseId), data);

export const createCourse = data =>
    HttpJsonService.postJson(urls.COURSES(), data);

export const deleteCourse = courseId =>
    HttpJsonService.deleteJson(urls.COURSES(courseId));

export const fetchSomeTccs = query => HttpJsonService.getJson(urls.TCCS, query);

export const fetchTccFile = query =>
    HttpJsonService.getJson(urls.TCC_FILE, query);

export const updateTCC = data => HttpJsonService.patchJson(urls.TCCS, data);

export const fetchSomeUsers = query =>
    HttpJsonService.getJson(urls.USERS, query);

export const fetchUser = id => HttpJsonService.getJson(urls.USER(id));

export const fetchTrainers = () => HttpJsonService.getJson(urls.TRAINERS);

export const createTrainer = params =>
    HttpJsonService.postJson(urls.TRAINERS, {}, params);

export const deleteTrainer = params =>
    HttpJsonService.deleteJson(urls.TRAINERS, params);

export const filterTrackedUsers = query =>
    HttpJsonService.getJson(urls.TRACKED, query);

export const fetchCenters = () => HttpJsonService.getJson(urls.CENTERS);

export const fetchEnrollments = data =>
    HttpJsonService.getJson(urls.ENROLLMENTS, data);

export const updateEnrollment = (classId, userId, data) =>
    HttpJsonService.patchJson(urls.ENROLLMENTS, data, { classId, userId });

export const enrollUser = data =>
    HttpJsonService.postJson(urls.ENROLLMENTS, {}, data);

export const unenrollUser = data =>
    HttpJsonService.deleteJson(urls.ENROLLMENTS, data);

export const fetchUserInfo = data => HttpJsonService.getJson(urls.USERS, data);

export const fetchAdmins = () => HttpJsonService.getJson(urls.ADMINS);

export const createAdmin = params =>
    HttpJsonService.postJson(urls.ADMINS, {}, params);

export const deleteAdmin = params =>
    HttpJsonService.deleteJson(urls.ADMINS, params);

export const requestFileUpload = (
    data,
    { fileName = 'fileName', mime = 'image/jpeg' },
) =>
    HttpJsonService.putJson(urls.FILE_UPLOAD, data, {
        headers: { 'Content-Type': mime, 'x-scis-filename': fileName },
    });

export const requestUrlToUploadAttachment = (
    userId,
    classId,
    mime,
    filename = 'filename',
) =>
    HttpJsonService.getJson(
        urls.REQUEST_URL_TO_ATTACHMENT(userId, classId, mime, filename),
    );

export const requestUploadAttachment = (
    url,
    data,
    { fileName = 'fileName', mime = 'image/jpeg' },
    callback,
) =>
    HttpJsonService.putJsonUploadAttach(
        url,
        data,
        { headers: { 'Content-Type': mime, 'x-scis-filename': fileName } },
        callback,
    );

export const requestAttachmentsList = (userId, classId) =>
    HttpJsonService.getJson(urls.REQUEST_ATTACH_LIST(userId, classId));

export const downloadingAttachment = (userId, classId, attachId) =>
    HttpJsonService.getJson(
        urls.DOWNLOAD_ATTACHMENT(userId, classId, attachId),
    );

export const deleteAttachment = (userId, classId, attachId) =>
    HttpJsonService.deleteJson(
        urls.REMOVE_ATTACHMENT(userId, classId, attachId),
    );

export const saveNewUser = data =>
    HttpJsonService.postJson(urls.ADD_NEW_USER(), data);

export const editUser = (userId, data) =>
    HttpJsonService.postJson(urls.ADD_NEW_USER(userId), data);

export const fetchTemplateQuestions = (params = {}) =>
    HttpJsonService.getJson(urls.TEMPLATE_QUESTIONS, params);

export const fetchTemplateQuestion = ({ questionId }) =>
    HttpJsonService.getJson(urls.TEMPLATE_QUESTION({ questionId }));

export const saveTemplateQuestions = data =>
    HttpJsonService.postJson(urls.TEMPLATE_QUESTIONS, data);

export const duplicateTemplateQuestions = ({ questionId }) =>
    HttpJsonService.postJson(urls.DUPLICATE_TEMPLATE_QUESTION({ questionId }));

export const updateTemplateQuestions = ({ questionId, data }) =>
    HttpJsonService.putJson(urls.TEMPLATE_QUESTION({ questionId }), data, {
        headers: {},
    });

export const deleteTemplateQuestion = ({ questionId }) =>
    HttpJsonService.deleteJson(urls.TEMPLATE_QUESTION({ questionId }));

export const fetchTemplateTest = ({ testId }) =>
    HttpJsonService.getJson(urls.TEMPLATE_TEST({ testId }));

export const duplicateTemplateTest = ({ testId }) =>
    HttpJsonService.postJson(urls.DUPLICATE_TEMPLATE_TEST({ testId }));

export const deleteTemplateTest = ({ testId }) =>
    HttpJsonService.deleteJson(urls.TEMPLATE_TEST({ testId }));

export const saveTemplateTest = data =>
    HttpJsonService.postJson(urls.TEMPLATE_TESTS, data);

export const updateTemplateTest = ({ testId, data }) =>
    HttpJsonService.putJson(urls.TEMPLATE_TEST({ testId }), data, {
        headers: {},
    });

export const saveQuestionsTemplateTest = ({ testId, data }) =>
    HttpJsonService.postJson(urls.BULK_TEMPLATE_TEST({ testId }), data);

export const deleteQuestionsTemplateTest = ({ testId, data }) =>
    HttpJsonService.deleteWithData(urls.BULK_TEMPLATE_TEST({ testId }), data);

export const fetchQuestionsTemplateTest = ({ testId }) =>
    HttpJsonService.getJson(urls.QUESTIONS_TEMPLATE_TEST({ testId }));
export const fetchPerfomedTests = ({ params = {} }) =>
    HttpJsonService.getJson(urls.PERFORMED_TESTS, params);

export const fetchExportPerfomedTests = (params) =>
    HttpJsonService.getJson(urls.PERFORMED_TESTS_EXPORT, params);

export const fetchTestTypes = () => HttpJsonService.getJson(urls.TEST_TYPES);

export const fetchTemplateTests = (params, isParams = false) =>
    HttpJsonService.getJson(urls.TEMPLATE_TESTS, isParams ? params: params.params);

export const updateCoursesTemplateTests = ({ courseId, data }) =>
    HttpJsonService.putJson(urls.COURSES_TEMPLATE_TESTS(courseId), data, {
        headers: {},
    });

export const fetchCoursesTemplateTests = ({ courseId }) =>
    HttpJsonService.getJson(urls.COURSES_TEMPLATE_TESTS(courseId));

export const updateClassesTemplateTests = ({ classId, data }) =>
    HttpJsonService.putJson(urls.CLASSES_TEMPLATE_TESTS(classId), data, {
        headers: {},
    });

export const fetchClassesTemplateTests = ({ classId }) =>
    HttpJsonService.getJson(urls.CLASSES_TEMPLATE_TESTS(classId));

export const fetchUserEad = ({ params = {} }) =>
    HttpJsonService.getJson(urls.EAD_USER, params);

export const withRetry = fn => async (...args) => {
    // HttpJsonService já implementa retry
    return await fn(...args);
};

export function goLogin() {
    const uri = encodeURIComponent(window.location.origin) + '/';
    window.location.replace(routes.LOGIN(uri));
}

export function goLogout() {
    const uri = encodeURIComponent(window.location.origin) + '/';
    window.location.replace(routes.LOGOUT(uri));
}



// WEBPACK FOOTER //
// ./src/utils/common-functions.js